module.exports = __webpack_public_path__ + "img/cue_logo.743759ea.svg";